// extracted by mini-css-extract-plugin
module.exports = {"rightSection":"styles_rightSection__716ow","hideScroll":"styles_hideScroll__3tzFQ"};